import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import classnames from 'classnames';
import StandardMenuContent from './StandardMenuContent';
import ScrollableMenuContent from './ScrollableMenuContent';
import { setRefs } from '../../../utils/refHelpers';
import { hasSubmenus } from '../../helpers';
import StandardMenuContext from './context';
import { StandardMenuType } from './types';
import s from './StandardMenu.scss';
const StandardMenu = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { id , items , className , label , scrollable =false , lightText , hideCheckIcon , menuClassName , itemClassName , groupClassName , labelClassName , withHoverEffect =true , withCardWrapper =true , withPaddings =true , withItemHorizontalPaddings =true , withScrollableArrows =false , menuType =StandardMenuType.DROPDOWN , onSelect , innerRef , children , itemsFillContainerWidth , role  } = _param, restProps = _object_without_properties(_param, [
        "id",
        "items",
        "className",
        "label",
        "scrollable",
        "lightText",
        "hideCheckIcon",
        "menuClassName",
        "itemClassName",
        "groupClassName",
        "labelClassName",
        "withHoverEffect",
        "withCardWrapper",
        "withPaddings",
        "withItemHorizontalPaddings",
        "withScrollableArrows",
        "menuType",
        "onSelect",
        "innerRef",
        "children",
        "itemsFillContainerWidth",
        "role"
    ]);
    const hasPaddings = withPaddings && !label;
    // TODO: submenus don't work with scrollable
    const isScrollable = (scrollable || !!label) && !hasSubmenus(items);
    const contentProps = {
        id,
        items,
        className: menuClassName,
        groupClassName,
        itemClassName: classnames(itemClassName, s['menu-item']),
        hideCheckIcon,
        withHoverEffect,
        lightText,
        onSelect,
        role
    };
    return /*#__PURE__*/ React.createElement(StandardMenuContext.Provider, {
        value: {
            menuType,
            role
        }
    }, /*#__PURE__*/ React.createElement("div", _extends({
        className: classnames('no-theme-skin', s['root'], withCardWrapper && s['with-card-wrapper'], hasPaddings && s['with-paddings'], !withItemHorizontalPaddings && s['without-item-horizontal-paddings'], className),
        ref: (node)=>setRefs([
                ref,
                innerRef
            ], node)
    }, restProps), isScrollable ? /*#__PURE__*/ React.createElement(ScrollableMenuContent, _extends({
        label: label,
        labelClassName: classnames(labelClassName, s['label']),
        withScrollableArrows: withScrollableArrows
    }, contentProps)) : /*#__PURE__*/ React.createElement(StandardMenuContent, _extends({}, contentProps)), children));
});
StandardMenu.displayName = 'StandardMenu';
export default StandardMenu;
